import { AppState } from '..'
import { useAppSelector } from '../hooks'

export const useSafeAppStatus = () => {
  return useAppSelector((state: AppState) => {
    return state.commonStore.isSafeApp
  })
}
